export function parseApiDate(value) {
    if (!value) return null;

    const text = String(value).trim();
    const hasZone = /[zZ]|[+-]\d{2}:?\d{2}$/.test(text);
    const naiveDateTime = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}/.test(text);

    const date =
        naiveDateTime && !hasZone
            ? new Date(`${text.replace(" ", "T")}+05:30`)
            : new Date(text);

    return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDateTime(value) {
    const date = parseApiDate(value);

    if (!date) return value ? String(value) : "";

    return date.toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    });
}

export function formatBusinessDate(dateString) {
    if (!dateString) return "";

    const match = String(dateString).match(/^(\d{4})-(\d{2})-(\d{2})/);

    if (!match) return String(dateString);

    const date = new Date(
        Number(match[1]),
        Number(match[2]) - 1,
        Number(match[3])
    );

    return date.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });
}

export function normalizeBusinessDate(value) {
    if (!value) return "";

    const match = String(value).match(/^\d{4}-\d{2}-\d{2}/);
    return match ? match[0] : String(value);
}

export function labelize(value) {
    if (!value) return "";

    return String(value)
        .toLowerCase()
        .split("_")
        .filter(Boolean)
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(" ");
}

export const FREQUENCY_HINT = {
    DAILY: "Daily",
    WEEKLY: "Every Sunday",
    BIWEEKLY: "2nd Sunday",
    MONTHLY: "Month end",
};
